import React, {useState} from 'react';
import {TituloMenu,ColFlex, RowStyle, DivPedidoContenido} from './style'
import {Row, Col, List, Card, Input, Button, Modal} from 'antd'
const { Search } = Input;
const data = [
     {
        nombre:"Abrazadera de guadaña",
        precio1:4,
        rango1:99,
        precio2:4,
        Categoria:"Acero para la construccion",
        caracteristicas:"Alambre recodio suave manejable para la construccion"
     },
     {
        nombre:"Alambron",
        Categoria:"Acero para la construccion",
        caracteristicas:"Alambrón Sicartsa (ArcelorMittal), 6.35 Tipo C para la construcción y en otras medidas y grados para diversas aplicaciones"
     },
     {
        nombre:"Cal Hidratada",
        Categoria:"Polvos y cementantes",
        caracteristicas:"Cal Hidratada en sacos de 25 kilogramos"
     },
    
];
  
const Precios = () => {

    const [visible, showModal]=useState(false)

    return (
        <>
            <TituloMenu>Lista de Precios</TituloMenu>
            {/* ---------------------------Filtros de Ordenes----------------------------- */}
            <RowStyle type="flex" justify="space-around" align="middle">
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Search placeholder="Numero de orden, cliente " onSearch={value => console.log(value)} enterButton />
                </ColFlex>
                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                    <div>
                        <Button type="primary" onClick={()=>showModal(true)}>
                            Agregar Producto
        </Button>
                        <Modal
                            title="Agregar Producto"
                            visible={visible}
                            onOk={()=>showModal(false)}
                            onCancel={()=>showModal(false)}
                        >
                            <p>Some contents...</p>
                            <p>Some contents...</p>
                            <p>Some contents...</p>
                        </Modal>
                    </div>
                </ColFlex>
            </RowStyle>

            <Row type="flex" justify="space-around" align="middle">
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                    <List
                     pagination={{
                        pageSize: 10,
                      }}
                        grid={{
                            gutter: 16,
                            xs: 1,
                            sm: 1,
                            md: 2,
                            lg: 2,
                            xl: 2,
                            xxl: 2,
                        }}
                        dataSource={data}
                        renderItem={item => (
                            <List.Item>
                                <Card title={item.cliente}>
                                    <Row type="flex" justify="space-around" align="middle">
                                        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                                            <DivPedidoContenido>
                                                <p>Nombre del producto: <span>{item.nombre}</span></p> 
                                                <p>Categoria: <span>{item.Categoria}</span></p>
                                                <p>Caracteristicas: <span>{item.caracteristicas}</span></p>
                                            </DivPedidoContenido>
                                        </Col>
                                      
                                        <Col l={12} lg={12} md={24}  sm={24} xs={24}>
                                                <Button>Descargar PDF</Button>
                                                <Button>Editar</Button>
                                        </Col>
                                    </Row>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Col>
            </Row>
        </>
    );
};

export default Precios;